/**
 * Strip HTML tags from a string so it can be safely displayed as plain text.
 * Matches website implementation (utils/stripHtml). Use for property listing
 * description/areaDescription that may contain raw HTML from integrations.
 */
export function stripHtml(html: string | null | undefined): string {
  if (html == null || typeof html !== 'string') {
    return '';
  }
  const withoutTags = html.replace(/<[^>]*>/g, '');

  return withoutTags
    .replace(/&#(\d+);?/g, (_, dec: string) => String.fromCharCode(Number(dec)))
    .replace(/&#x([0-9a-fA-F]+);?/g, (_, hex: string) =>
      String.fromCharCode(parseInt(hex, 16)),
    )
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}
